// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceUsageContent,
  unionToDeviceUsageContent,
  unionListToDeviceUsageContent,
} from "./device-usage-content";
import {
  ElevatorUsageMessage,
  ElevatorUsageMessageT,
  verifyElevatorUsageMessage,
} from "./elevator-usage-message";
import {
  EscalatorUsageMessage,
  EscalatorUsageMessageT,
  verifyEscalatorUsageMessage,
} from "./escalator-usage-message";

export class UsageMessage implements flatbuffers.IUnpackableObject<UsageMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UsageMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUsageMessage(bb: flatbuffers.ByteBuffer, obj?: UsageMessage): UsageMessage {
    return (obj || new UsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUsageMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageMessage,
  ): UsageMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  messageType(): DeviceUsageContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceUsageContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startUsageMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: DeviceUsageContent) {
    builder.addFieldInt8(0, messageType, DeviceUsageContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endUsageMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createUsageMessage(
    builder: flatbuffers.Builder,
    messageType: DeviceUsageContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    UsageMessage.startUsageMessage(builder);
    UsageMessage.addMessageType(builder, messageType);
    UsageMessage.addMessage(builder, messageOffset);
    return UsageMessage.endUsageMessage(builder);
  }

  unpack(): UsageMessageT {
    return new UsageMessageT(
      this.messageType(),
      (() => {
        const temp = unionToDeviceUsageContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: UsageMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToDeviceUsageContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): UsageMessageT {
    const t = new UsageMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToDeviceUsageContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class UsageMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: DeviceUsageContent = DeviceUsageContent.NONE,
    public message: ElevatorUsageMessageT | EscalatorUsageMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return UsageMessage.createUsageMessage(builder, this.messageType, message);
  }

  clone(): UsageMessageT {
    const obj = new UsageMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: UsageMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyUsageMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorUsageMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorUsageMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorUsageMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorUsageMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
